import { marked } from "marked";

// Configure marked to open links in new tabs
const renderer = new marked.Renderer();
const originalLinkRenderer = renderer.link.bind(renderer);

renderer.link = (href, title, text) => {
  const html = originalLinkRenderer(href, title, text);
  return html.replace("<a", '<a target="_blank" rel="noopener noreferrer"');
};

marked.setOptions({
  renderer,
  breaks: true, // Convert line breaks to <br>
  gfm: true, // GitHub Flavored Markdown
});

export const parseMarkdown = (content: string): string => {
  return marked(content) as string;
};

